export const convertDateToUTC = (date, formatter) => {
    return new Date(formatter(date));
};
